import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "../hooks/useSessionHook";
import { clearSessionData } from "@/lib/utils";

const AuthProtectedRoute = () => {
  const { session, profile } = useSession();
  
  if (!session) {
    console.log("AuthProtectedRoute.tsx: No session object, clearingSessionData, and redirecting to home page");
    clearSessionData();
    return <Navigate to="/" replace />;
  }

  if (!profile) {
    console.log("AuthProtectedRoute.tsx: Session exists but profile not loaded yet, showing loader");
    return <div className="w-full h-screen flex items-center justify-center">Loading profile...</div>;
  }
  
  console.log("AuthProtectedRoute.tsx: Valid session object, redirecting to <Output/> page");
  return <Outlet /> 
};

export default AuthProtectedRoute;
